var _rect, _path, _path2, _path3, _rect2, _path4, _rect3, _path5, _path6, _rect4, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFliqTypeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 32,
    viewBox: "0 0 148 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E4E4E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.785 8.21517C22.9649 7.39507 21.6352 7.39507 20.8151 8.21517L19.8894 9.14089L22.8592 12.1107L23.785 11.185C24.6051 10.3649 24.6051 9.03527 23.785 8.21517Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0107 12.9593L19.0409 9.98942L12.3202 16.7101C11.8268 17.2035 11.4641 17.8121 11.2648 18.4809L10.625 20.6288C10.5621 20.8399 10.62 21.0686 10.7758 21.2244C10.9316 21.3801 11.1602 21.438 11.3713 21.3751L13.5192 20.7353C14.188 20.5361 14.7966 20.1734 15.2901 19.6799L22.0107 12.9593Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 10.6001C9.27456 10.6001 8.20004 11.6746 8.20004 13.0001V21.4001C8.20004 22.7256 9.27456 23.8001 10.6 23.8001H19C20.3255 23.8001 21.4 22.7256 21.4 21.4001V17.2001C21.4 16.8687 21.1314 16.6001 20.8 16.6001C20.4687 16.6001 20.2 16.8687 20.2 17.2001V21.4001C20.2 22.0628 19.6628 22.6001 19 22.6001H10.6C9.9373 22.6001 9.40004 22.0628 9.40004 21.4001V13.0001C9.40004 12.3373 9.9373 11.8001 10.6 11.8001H14.8C15.1314 11.8001 15.4 11.5315 15.4 11.2001C15.4 10.8687 15.1314 10.6001 14.8 10.6001H10.6Z",
    fill: "#1A1A1A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E4E4E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 11.1999C46 10.2058 46.8059 9.3999 47.8 9.3999H61C61.9942 9.3999 62.8 10.2058 62.8 11.1999V20.7999C62.8 21.794 61.9942 22.5999 61 22.5999H47.8C46.8059 22.5999 46 21.794 46 20.7999V11.1999ZM47.2 19.2484V20.7999C47.2 21.1313 47.4687 21.3999 47.8 21.3999H61C61.3314 21.3999 61.6 21.1313 61.6 20.7999V19.2484L59.4486 17.097C58.9799 16.6283 58.2201 16.6283 57.7515 17.097L57.0486 17.7999L57.8243 18.5756C58.0586 18.81 58.0586 19.1899 57.8243 19.4242C57.59 19.6585 57.2101 19.6585 56.9758 19.4242L52.8486 15.297C52.3799 14.8283 51.6201 14.8283 51.1515 15.297L47.2 19.2484ZM55.3 12.9999C55.3 12.5028 55.703 12.0999 56.2 12.0999C56.6971 12.0999 57.1 12.5028 57.1 12.9999C57.1 13.497 56.6971 13.8999 56.2 13.8999C55.703 13.8999 55.3 13.497 55.3 12.9999Z",
    fill: "#1A1A1A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76.8,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E4E4E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8 10C89.8 8.34315 91.1432 7 92.8 7C94.4569 7 95.8 8.34315 95.8 10V16.6C95.8 18.2569 94.4569 19.6 92.8 19.6C91.1432 19.6 89.8 18.2569 89.8 16.6V10Z",
    fill: "#1A1A1A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88 14.8C88.3314 14.8 88.6 15.0686 88.6 15.4V16.6C88.6 18.9196 90.4804 20.8 92.8 20.8C95.1196 20.8 97 18.9196 97 16.6V15.4C97 15.0686 97.2687 14.8 97.6 14.8C97.9314 14.8 98.2 15.0686 98.2 15.4V16.6C98.2 19.3795 96.1 21.6686 93.4 21.967V23.8H95.8C96.1314 23.8 96.4 24.0686 96.4 24.4C96.4 24.7314 96.1314 25 95.8 25H89.8C89.4687 25 89.2 24.7314 89.2 24.4C89.2 24.0686 89.4687 23.8 89.8 23.8H92.2V21.967C89.5001 21.6686 87.4 19.3795 87.4 16.6V15.4C87.4 15.0686 87.6687 14.8 88 14.8Z",
    fill: "#1A1A1A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 115.2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E4E4E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.3 8.19971C135.472 8.19971 134.8 8.87128 134.8 9.69971V22.2997C134.8 23.1281 135.472 23.7997 136.3 23.7997H136.9C137.728 23.7997 138.4 23.1281 138.4 22.2997V9.69971C138.4 8.87128 137.728 8.19971 136.9 8.19971H136.3Z",
    fill: "#1A1A1A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.4 13.2997C129.4 12.4713 130.072 11.7997 130.9 11.7997H131.5C132.328 11.7997 133 12.4713 133 13.2997V22.2997C133 23.1281 132.328 23.7997 131.5 23.7997H130.9C130.072 23.7997 129.4 23.1281 129.4 22.2997V13.2997Z",
    fill: "#1A1A1A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124 16.8997C124 16.0713 124.672 15.3997 125.5 15.3997H126.1C126.928 15.3997 127.6 16.0713 127.6 16.8997V22.2997C127.6 23.1281 126.928 23.7997 126.1 23.7997H125.5C124.672 23.7997 124 23.1281 124 22.2997V16.8997Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFliqTypeIcon);
export default __webpack_public_path__ + "static/media/fliq_type_icon.a7b440e14ab4127064d5f6dd77bc2227.svg";
export { ForwardRef as ReactComponent };